import { AppShell as MantineAppShell } from "@mantine/core";
import { Provider as QRPageProvider } from "jotai";
import { FunctionComponent, PropsWithChildren } from "react";
import { Outlet } from "react-router-dom";

import { DevtoolsPanel } from "#app/devtools/DevtoolsPanel";
import { Header } from "#shared/view/components/AppShell/Header";

type AppShellProps = PropsWithChildren<{ noHeader?: boolean }>;

export const AppShell: FunctionComponent<AppShellProps> = ({ noHeader = false }) => {
  return (
    <QRPageProvider>
      <MantineAppShell padding={0}>
        <MantineAppShell.Main h="100dvh">
          {!noHeader && <Header />}
          <Outlet />
          <DevtoolsPanel />
        </MantineAppShell.Main>
      </MantineAppShell>
    </QRPageProvider>
  );
};
